var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.layout,{directives:[{name:"show",rawName:"v-show",value:(_vm.loaded),expression:"loaded"}],tag:"component",staticClass:"content"},[_vm._t("default"),_c('cookie-consent-modal')],2)}
var staticRenderFns = []

export { render, staticRenderFns }